import { render, staticRenderFns } from "./innerSinglePartList.vue?vue&type=template&id=44b24b4f&scoped=true"
import script from "./innerSinglePartList.vue?vue&type=script&lang=js"
export * from "./innerSinglePartList.vue?vue&type=script&lang=js"
import style0 from "./innerSinglePartList.vue?vue&type=style&index=0&id=44b24b4f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b24b4f",
  null
  
)

export default component.exports